import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=136e0b31&"
import script from "./menu-bar.vue?vue&type=script&lang=js&"
export * from "./menu-bar.vue?vue&type=script&lang=js&"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=136e0b31&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports